<script>
	import next from 'array-next'
	import prev from 'array-previous'
	import { fade } from 'svelte/transition'
	import { sineOut } from 'svelte/easing'

	export let fields = {}
	let { testimonials } = fields

	let windowWidth = window.innerWidth

	let activeTestimonial = testimonials[0]

	let dir

	function changeProject(toNext) {
		dir = toNext
		let newTestimonial = toNext
			? next(testimonials, activeTestimonial)
			: prev(testimonials, activeTestimonial)
		activeTestimonial = newTestimonial
	}

	// function maskIn(node, { duration, delay, easing, reverse }) {
	// 	return {
	// 		delay,
	// 		duration,
	// 		css: t => {
	// 			const eased = (easing ? easing : cubicInOut)(t)
	// 			const amt = eased * 200
	// 			return `-webkit-mask-image: linear-gradient(to ${
	// 				dir ? 'left' : 'right'
	// 			}, rgba(0, 0, 0, 1) ${amt - 100}%, transparent ${amt}%)`
	// 		},
	// 	}
	// }

	let startX

	const touchstart = ({ changedTouches }) => {
		startX = changedTouches[0].pageX
	}
	const touchend = ({ changedTouches }) => {
		const distX = changedTouches[0].pageX - startX
		if (distX < -60) {
			dir = 1
			changeProject(1)
		} else if (distX > 60) {
			dir = 0
			changeProject(0)
		}
	}
</script>

<svelte:window bind:innerWidth={windowWidth} />

{#if windowWidth > 999}
	<!-- desktop -->
	<div class="testimonial-backgrounds">
		{#each testimonials as testimonial}
			<div
				class:active={testimonial === activeTestimonial}
				style="background-image:url({testimonial.background})" />
		{/each}
	</div>
	<div class="slide-testimonials">
		<div class="st-header">
			<h2>Living Without Pain</h2>
			<h3>Patient Testimonials</h3>
		</div>
		<div class="st-sections">
			{#each testimonials as testimonial}
				<div
					class="s-testimonial"
					class:active={testimonial === activeTestimonial}>
					<div class="st-img circle-img">
						<div
							style="background-image:url({testimonial.img || '/wp-content/uploads/2020/06/blue-background.jpg'})" />
					</div>
					<div class="st-content">
						<h5>{testimonial.procedure}</h5>
						<h4>{testimonial.name}</h4>
						<div class="st-summary">
							{#if testimonial.summaryLead}
								<em>{testimonial.summaryLead}</em>
							{/if}
							<p>
								{@html testimonial.summary}
							</p>
							<a href={testimonial.url} class="pointer-link">Read more</a>
						</div>
					</div>
				</div>
			{/each}
		</div>
	</div>

	<div class="st-links">
		{#each testimonials as testimonial}
			<a
				href={testimonial.url}
				on:mouseenter={() => (activeTestimonial = testimonial)}>
				<span class="sr-only">{testimonial.name}</span>
			</a>
		{/each}
	</div>
{:else}
	<!-- device -->
	<div
		class="slide-testimonials responsive"
		data-no-panel
		on:touchstart={touchstart}
		on:touchend={touchend}>
		<div class="testimonial-slide">
			{#each [activeTestimonial] as testimonial (testimonial.background)}
				<div
					class="s-testimonial-background"
					style="background-image:url({testimonial.background})"
					in:fade={{ duration: 500, easing: sineOut }}
					out:fade={{ duration: 1, delay: 499 }} />
			{/each}
			<div class="s-testimonial">
				<div class="st-header">
					<h2>Living Without Pain</h2>
					<h3>Patient Testimonials</h3>
				</div>
				<div class="res-stcs">
					{#each [activeTestimonial] as testimonial (testimonial.background)}
						<div
							in:fade={{ duration: 500, easing: sineOut }}
							out:fade={{ duration: 300 }}>
							<div class="st-img circle-img">
								<div style="background-image:url({testimonial.img})" />
							</div>
							<div class="st-content">
								<h5>{testimonial.procedure}</h5>
								<h4>{testimonial.name}</h4>
								<div class="st-summary">
									{#if testimonial.summaryLead}
										<em>{testimonial.summaryLead}</em>
									{/if}
									<p>
										{@html testimonial.summary}
									</p>
									<a href={testimonial.url} class="pointer-link">Read more</a>
								</div>
							</div>
						</div>
					{/each}
				</div>
			</div>
		</div>
	</div>
	<button class="left" on:click={() => changeProject(0)}>
		<svg width="42px" height="42px" viewBox="0 0 24 24">
			<path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z" />
		</svg>
	</button>
	<button class="right" on:click={() => changeProject(1)}>
		<svg width="42px" height="42px" viewBox="0 0 24 24">
			<path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z" />
		</svg>
	</button>
{/if}
